<template>
  <v-container class="fill-height pa-0 ma-0 chat-drawer-container fluid">
    
    <template v-if="!$vuetify.breakpoint.smAndDown">
      
      <v-layout row>

        
        <v-flex lg3 class="chat-contact--sidebar white">

          
          <chat-contact-list></chat-contact-list>
        </v-flex>
        <v-flex >
              <v-toolbar card dense flat class="white chat-room--toolbar" light>

            <template>
        <!-- Top level -->
                  <v-list-tile href="#/chat/friend" class="py-2 mini-tile my-2" avatar>
          <v-icon color="blue" class="v-icon mini-icon material-icons" size="36">person_pin</v-icon>
        </v-list-tile>
        <v-list-tile href="#/chat/messaging" class="py-2 mini-tile my-2" avatar>
          <v-icon color="blue" class="v-icon mini-icon material-icons" size="36">chat</v-icon>
        </v-list-tile>
      </template>
    </v-toolbar> 
          <chat-contact-profile></chat-contact-profile>
        </v-flex>
      </v-layout>
    </template>
<!--     <template v-else>
      <v-layout column>
        <v-flex sm12 class="white" v-if="showSidebar">
          <chat-contact-list></chat-contact-list>
        </v-flex>
        <v-flex sm12 v-if="showWindow">
          <chat-contact-profile></chat-contact-profile>
        </v-flex>
      </v-layout>
    </template> -->
  </v-container>
</template>
<script>
import ChatContactList from "./ChatContactList";
import ChatContactProfile from "./ChatContactProfile";
export default {
  components: {
    ChatContactList,
    ChatContactProfile
  },
  data() {
    return {
      chat: null,
      selectedTab: null
    };
  },
  computed: {
    showSidebar() {
     // return true;
    return this.$route.params.uuid === undefined;
    },
    showWindow() {
     // return true;
        return this.$route.params.uuid !== undefined;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/chat/ChatContact.vue